var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"distribution-channels-page"},[_c('div',{staticClass:"distribution-channels-resullts"},_vm._l((_vm.distributionChannels),function(dt){return _c('distribution-channel-card',{key:dt.uuid,attrs:{"distribution-channel":dt}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }